import { FC, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { EmptyState, GroupedList, TransactionListItem } from "../../lib";
import { listTransactionsApi } from "../../utils/api/transactions-apis";
import { createFilterObject, TransactionsFilters } from "../filters";
import { dateRange } from "../query-builder/date-picker";

type Props = {
  limit?: number;
  activeTab?: string;
  refresh: boolean;
  terminal_id?: string;
  merchantId?: string;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setTransactionsForDownload?: any;
  queryParams?: {
    [key: string]: any;
  };
  dateRange?: dateRange;
};

const ListTransactions: FC<Props> = ({
  refresh,
  terminal_id,
  merchantId,
  setIsLoading,
  activeTab,
  limit = 30,
  setTransactionsForDownload,
  queryParams = {},
  dateRange = {},
}: Props) => {
  const [transactions, setTransactions] = useState<any>([]);
  const [pages, setPages] = useState(1);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchTransactions = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await listTransactionsApi({
        page,
        filter: createFilterObject(
          activeTab ? activeTab : "",
          TransactionsFilters
        ),
        merchantId,
        limit,
        terminal_id,
        queryParams: queryParams as {
          [key: string]: any;
        },
        dateRange,
      });
      setPages(response.pages);
      setTransactions(response.transactions);
      setTransactionsForDownload?.(response.transactions);
      setIsLoading(false);
    } catch (e) {
      console.log({ e });
      setIsLoading(false);
    }
  };

  const goToTransaction = (transaction: any) =>
    navigate("/transactions/" + transaction.uuid);

  useEffect(() => {
    fetchTransactions();
  }, [refresh, activeTab]);

  return transactions?.length ? (
    <GroupedList
      pages={{
        total: pages,
        selectPage: (page: number) => fetchTransactions(page),
      }}
      onItemClick={(item) => goToTransaction(item)}
      role={"client"}
      data={transactions}
      component={TransactionListItem}
      groupBy={{
        key: "created_at",
        isDate: true,
      }}
    />
  ) : (
    <EmptyState title={t("itemNotFound")} />
  );
};

export default ListTransactions;
